const educationData = [
    {
        id: 1001,
        title: "BS Computer Science",
        institute: "University of Bahawalpur",
        duration: "2022-2024",
        result: "3.87/4",
        description: "This program focused on software engineering, data structures, algorithms, databases, and web development skills for real-world applications."
    },
    {
        id: 1002,
        title: "Intermediate of Computer Science",
        institute: "Aspire College Mailsi",
        duration: "2020-2022",
        result: "953/1100",
        description: "Covered fundamentals of computer science, including programming, database systems, and networking, along with core science and mathematics subjects."
    },
    {
        id: 1003,
        title: "Matric",
        institute: "GOVT. High School Kotmuzaffar",
        duration: "2018-2020",
        result: "999/1100",
        description: "Focused on foundational subjects like mathematics, science, and computers, laying the groundwork for higher education in technology."
    }
]

export default educationData;
